'use strict';

var dialog = require('../../dialog'),
	minicart = require('../../minicart'),
	page = require('../../page'),
	util = require('../../util'),
	TPromise = require('promise'),
	_ = require('lodash'),
	linchpin = require('int_googletagmanager/linchpin/addToCart'),
	linchpinGiftGuru = require('int_googletagmanager/linchpin/giftguru'),
	ordergroove = require('int_ordergroove/ordergroove/product');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @param {Number} pid optional product id to add to the basket
 * @returns {Promise}
 */
var addItemToCart = function (form, pid, quantity) {
	var data = {},
		url = util.ajaxUrl(Urls.addProduct);

	if (!pid) {
		var $form = $(form),
			$qty = $form.find('input[name="Quantity"]');
		pid = $form.find('input[name="pid"]').val();
		if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
			$qty.val('1');
		}
		data = $form.serialize();
	} else {
		url = util.appendParamsToUrl(url, {
			Quantity: quantity ? quantity : '1',
			cartAction: 'add',
			pid: pid
		});
	}

	var listName = linchpin.getImpressionList(pid);
	url = util.appendParamToURL(url, 'impressionList', listName);

	return TPromise.resolve($.ajax({
		type: 'POST',
		url: url,
		data: data
	}));
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
	e.preventDefault();
	var $this = $(this),
		$form = $this.closest('form'),
		giftCardAmount = $form.find('input.gift-cert-amount').val(),
		pid = $this.data('addToBagPid');

	addItemToCart($form, pid).then(function (response) {
		var $uuid = $form.find('input[name="uuid"]');
		ordergroove.addToCart($form);
		if ($uuid.length > 0 && $uuid.val().length > 0) {
			page.redirect(Urls.cartShow);
		} else if (response.success === false && response.error === 'CART_MAX') {
			dialog.open({
				url: Urls.maxLineItemQuota,
				options: {
					buttons: [
						{
							text: Resources.GOT_IT,
							'class':'maxLineItemQuota-btn',
							click: function () {
								$(this).dialog('close');
							}
						}
					],
					title: Resources.MAX_QUOTA_TITLE
				}
			});
		} else if (response.success === false && response.error === 'TC_DEBT') {
			dialog.open({
				url: Urls.tcSettleBalanceError,
				options: {
					buttons: [
						{
							text: Resources.CANCEL,
							'class':'button-gray',
							click: function () {
								$(this).dialog('close');
							}
						},
						{
							text: Resources.SETTLE_BALANCE,
							click: function () {
								window.location = Urls.shippingStart;
							}
						}
					],
					title: Resources.SORRY
				}
			});
		} else if (response.success === false && response.errors !== null) {
			// Physical gift card error handling
			$form.find('span.error').hide();
			for (var id in response.errors.FormErrors) {
				var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
				if (!$errorEl || $errorEl.length === 0) {
					$errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
					$('#' + id).after($errorEl);
				}
				$errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
			}
		} else {
			// do not close quickview if adding individual item that is part of product set
			// @TODO should notify the user some other way that the add action has completed successfully
			if (!$(this).hasClass('sub-product-item')) {
				dialog.close();
			}
			// special processing for tasting club introductory boxes
			if ($this.hasClass('select-introductory-box')) {
				$this.prop('disabled', true).text(Resources.ADDED_TO_BAG);
			}
			if (page.ns === 'cart') {
				page.refresh();
			} else {
				minicart.show(response);
			}
			// Clean amount field for physical gift card
			$form.find('input[name$="amount"]').val('');
			//activate checkout link in the header
			$('.checkout-link').removeClass('display-none');
		}

		if (window.algoliaData && window.algoliaData.enable) {
			var event = new CustomEvent('algoliainsights:addtobag');
			document.dispatchEvent(event);
		}

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			var $tastingClub = $form.find('input[name="tastingClub"]');
			if ($tastingClub.length > 0) {
				linchpin.boxAddedToBasket(e);
			} else {
				linchpin.addToBagEvent(e, giftCardAmount);
			}

			// Gift guru giftAddedToBag event
			var giftGuruBanner = $('.giftguru-finish-banner:visible');
			if (giftGuruBanner.length > 0) {
				var $recipientAddress = giftGuruBanner.find('input[name="giftGuruRecipientAddress"]');
				if ($recipientAddress.val()) {
					var recipientAddress = getAddressAsString(JSON.parse($recipientAddress.val()));
					linchpinGiftGuru.giftAddedToBagEvent(e, recipientAddress);
				}
			}
		}
	}.bind(this));
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
	e.preventDefault();
	var $productForms = $('#product-set-list').find('form').toArray();
	TPromise.all(_.map($productForms, addItemToCart))
		.then(function (responses) {
			dialog.close();
			// show the final response only, which would include all the other items
			minicart.show(responses[responses.length - 1]);
			if (window.algoliaData && window.algoliaData.enable) {
				var event = new CustomEvent('algoliainsights:addtobag');
				document.dispatchEvent(event);
			}
		});
};

/**
 * @description returns string representation of address object
 */
function getAddressAsString(addrObj) {
	var fields = [];
	fields.push(addrObj.title || '');
	fields.push(addrObj.jobTitle || '');
	fields.push(addrObj.companyName || '');
	fields.push(addrObj.firstName || '');
	fields.push(addrObj.lastName || '');
	fields.push(addrObj.address1 || '');
	fields.push(addrObj.address2 || '');
	fields.push(addrObj.city || '');
	fields.push(addrObj.stateCode || '');
	fields.push(addrObj.postalCode || '');
	fields.push(addrObj.countryCode || '');
	fields.push(addrObj.phone || '');

	return fields.join(' ').replace(/\s+/g, ' ').trim();
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 * @param {Element} target The target on which an add to cart event-handler will be set
 * @param {Boolean} initGlobalEvents indicates if need to initialize AddToCart links from content assets / slots
 */
module.exports = function (target, initGlobalEvents) {
	if (initGlobalEvents) {
		// Add handlers for links from content assets / slots
		// Avoid multiple event listeners on AddToBag buttons
		$(document).off('click.globaladdtocart');
		$(document).on('click.globaladdtocart', '[data-add-to-bag-pid]', addToCart);

	} else {
		$('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());

		if (target) {
			target.on('click', '.add-to-cart', addToCart);
		} else {
			$('.add-to-cart').on('click', addToCart);
		}
		$('#add-all-to-cart').on('click', addAllToCart);
		$('#add-all-to-cart-recipe').on('click', addAllToCart);
		if ($('#pdpMain').find('.cross-sell-recommendations').length) {
			$('.add-to-cart').on('click', function() {
				var $selectedRecItems = $('.recommendation-item.selected');
				if ($selectedRecItems.length) {
					$selectedRecItems.each(function () {
						addItemToCart(null, $(this).find('[name="pid"]').val(), $(this).find('[name="quantity"]').val())
						.then(function (response) {
							minicart.show(response);
							if (window.algoliaData && window.algoliaData.enable) {
								var event = new CustomEvent('algoliainsights:addtobag');
								document.dispatchEvent(event);
							}
						});
					});
				}
			});
		}
	}
};
